'use client'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'
import { generatePageNumbers } from './page-navigation.utils'
import { usePageLink } from './page-navigation.hooks'
import { cn } from '@/lib/utils'

type PageNavigationProps = {
  currentPage: number
  totalPages: number
  paramName: string
  labels: {
    previous: string
    next: string
  }
}

const PageNavigation = ({
  currentPage,
  totalPages,
  paramName,
  labels,
}: PageNavigationProps) => {
  const prevPage = currentPage - 1
  const nextPage = currentPage + 1
  const pageNumbers = generatePageNumbers(currentPage, totalPages)
  const getLink = usePageLink(paramName)

  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            className={cn(prevPage < 1 && 'pointer-events-none opacity-70')}
            href={getLink(prevPage)}
          >
            {labels.previous}
          </PaginationPrevious>
        </PaginationItem>

        {pageNumbers.map((pageNumber) => (
          <PaginationItem key={pageNumber}>
            <PaginationLink
              href={getLink(pageNumber)}
              isActive={pageNumber === currentPage}
            >
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem>
          <PaginationNext
            className={cn(
              nextPage > totalPages && 'pointer-events-none opacity-70',
            )}
            href={getLink(nextPage)}
          >
            {labels.next}
          </PaginationNext>
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}

export default PageNavigation
